import {Component, OnInit, OnDestroy} from '@angular/core';
import * as _ from 'lodash';
import { TruExpressService } from '../services/truexpress.service';
import { ExpressPrice } from '../model/truexpress';
import { Customer } from '../model/customer';
import { Quote } from '../model/quote';
import { CustomerService } from '../services/customer.service';
import { QuoteRevisionService } from '../services/quote-revision.service';
import { HttpResponseService } from '../services/httpresponse-service';
import { QuoteService } from '../services/quote.service';
import { CurrentUserService } from '../services/current-user.service';
import { Router } from '@angular/router';
import { QuoteRevision } from '../model/quote-revision';
import { AppComponent } from '../app.component'; 
import { LoadingSpinnerService } from '../services/loading-spinner.service';
import { ModelService } from '../services/model.service';
import { SplunkLogEventType, SplunkLogStatement } from '../model/splunk-log-statement';
import { SplunkLogService } from '../services/splunk-log.service';

@Component({
    selector: 'truexp',
    template: require('./truexp.component.html')
})
export class TruExpComponent implements OnInit {

    TruExpArray: any;     
    isBusy: boolean = false;
    stockHome: boolean;
    customer: Customer;
    quote: Quote;
    quoteupdate: Quote; 
    quoteRevision: QuoteRevision;
    customerId: number; 
    quoteId: number; 
    currentUserId: number;
    splunkLogStatement: SplunkLogStatement;
    currentRetailerNumber: string;
    revisionComments: string; 
    appComponent: AppComponent;

    constructor(
        public truexpressservice: TruExpressService,
        public httpResponseService: HttpResponseService,
        public customerService: CustomerService,
        public currentUserService: CurrentUserService,
        public quoteService: QuoteService, 
        public spinner: LoadingSpinnerService,
        public quoteRevisionService: QuoteRevisionService,
        public modelService: ModelService,
        public splunkLogService: SplunkLogService,
        public router: Router
    )
    {
        this.splunkLogStatement = new SplunkLogStatement();
        const currentUserSub = this.currentUserService.currentUser$.subscribe(x => {
            this.currentUserId = x.cmhUserId;
            this.currentRetailerNumber = x.retailerNumber;
            this.splunkLogStatement.SetUser(x.cmhUserId, x.userName, 
                currentUserService.getUserType(x.isPlantUser, x.isInternal));
            this.splunkLogStatement.SetRetailer(x.retailerNumber, x.retailerName, x.currentRetailer.retailerType);
        });
    }
    
    ngOnInit(): void {
        this.spinner.showSpinner();    
        this.getTruExp();    
    }

    getTruExp() {
        this.TruExpArray = new Array();
        this.isBusy = true;

        this.splunkLogStatement.SetEvent(SplunkLogEventType.TRUExpress);
        this.splunkLogService.log(this.splunkLogStatement).subscribe();

        this.truexpressservice.getTruExpressPricing(this.currentRetailerNumber)
            .subscribe(truexp => {
                this.TruExpArray = truexp;
                this.TruExpArray.sort(function (a, b) {
                    if (a.ModelDescription < b.ModelDescription) return -1;
                    if (a.ModelDescription > b.ModelDescription) return 1;
                });
            },
                (error) => {
                    console.log('error');
                },
            () => {

                    this.spinner.hideSpinner();
                    this.isBusy = false;
            });
    }
    
    onQuoteClick(plantID: number, productLineID: number, modelID: number) {
        this.spinner.showSpinner();
        this.customer = new Customer();
        this.customer.firstName = 'Stock';
        this.customer.lastName = 'Home';

        this.quote = new Quote();
        this.quote.plantId = plantID;
        this.quote.modelId = modelID;
        this.quote.productLineId = productLineID;
        this.quote.retailerNumber = this.currentRetailerNumber;
        this.quote.revisionNumber = 1;
        this.quote.userId = this.currentUserId;
        
        this.quoteRevision = new QuoteRevision();
        this.quoteRevision.RevisionComments = "Quote Created";
        this.quoteRevision.RevisionNumber = 1;

        this.customerService.insertCustomer(this.customer).subscribe(
            customer => {
                this.customerId = customer.customerId;
                this.quote.customerId = this.customerId;

                this.quoteService.insertQuote(this.quote).subscribe(
                    quote => {
                        this.quote.quoteId = quote.quoteId;
                        this.quoteRevision.QuoteId = quote.quoteId;

                        this.quoteRevisionService.insertQuoteRevision(this.quoteRevision).subscribe(
                            quoteRevision => {
                                quoteRevision.QuoteId = quote.quoteId;
                                this.modelService.setBaseOptionsForModel(quote.quoteId, parseInt(this.currentRetailerNumber)).subscribe(
                                    result => {
                                        this.spinner.hideSpinner();
                                        this.router.navigateByUrl(`/options-configuration/${this.quote.quoteId}`);
                                });
                        });
                });
        });
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/truexp/truexp.component.ts